import { IMatter } from "../interfaces";

const itemsMatter: IMatter[] = [
  {
    id: "1",
    title: "title_matter_1",
    description: "description_matter_1",
    img: "m1-img1.png",
  },
  {
    id: "2",
    title: "title_matter_2",
    description: "description_matter_2",
    img: "m2-img1.png",
  },
  {
    id: "3",
    title: "title_matter_3",
    description: "description_matter_3",
    img: "m2-img4.png",
  },
  {
    id: "4",
    title: "title_matter_4",
    description: "description_matter_4",
    img: "m4-img2.png",
  },
  {
    id: "5",
    title: "title_matter_5",
    description: "description_matter_5",
    img: "m4-img2.png",
  },
  {
    id: "6",
    title: "title_matter_6",
    description: "description_matter_6",
    img: "m4-img2.png",
  },
  {
    id: "7",
    title: "title_matter_7",
    description: "description_matter_7",
    img: "m7-img1.png",
  },
];

export { itemsMatter };
